import { HtmlHTMLAttributes } from "react";
import styled from "styled-components";
import {
  color,
  ColorProps,
  compose,
  space,
  SpaceProps,
  typography,
  TypographyProps,
  textStyle,
  TextStyleProps,
  system,
  MarginProps,
  margin,
} from "styled-system";

export const Text = styled.p<
  HtmlHTMLAttributes<HTMLParagraphElement> &
    TypographyProps &
    ColorProps &
    SpaceProps &
    MarginProps &
    TextStyleProps & { whiteSpace?: "normal" | "pre-line" | "break" }
>(
  compose(margin, typography, color, space, textStyle),

  system({
    whiteSpace: {
      property: "whiteSpace",
    },
  })
);

Text.defaultProps = {
  whiteSpace: "pre-line",
  margin: "0px",
};

Text.displayName = "Text";
